import React, { Component } from 'react';

import Console from '../../../../lib/debug';

export default class MiniCalendarDay extends Component {
    handleMouseEnter() {
        this.props.onEnter(`${this.props.week}_${this.props.day}`);
    }
    handleOnSelect() {
        this.props.onSelect({ week: this.props.week, day: this.props.day });
    }
    render() {
        Console.render('designer.MiniCalendarDay');
        let dots = [];
        let sessions = this.props.sessions || [];
        let index = this.props.index;
        let key = `day-item-${index}`;

        if (sessions.length) {
            for (var k = 0; k < sessions.length; k++) {
                if (k <= 2) {
                    dots.push(<div className="dot" key={`dot-${k}`} />);
                } else {
                    break;
                }
            }
        }
        let dayClasses = `day-item${this.props.isSelected ? ' selected' : ''}`;
        return (
            <div
                className={dayClasses}
                key={key}
                onMouseEnter={this.handleMouseEnter.bind(this)}
                onClick={this.handleOnSelect.bind(this)}
            >
                <div className="day-item-title">{index + 1}</div>
                <div className="dots">{dots}</div>
            </div>
        );
    }
}
